<template>
  <Dialog v-model="currentVisible" :title="$t('Are you sure?')" width="400px">
    <p>{{ $t('This operation can not be canceled.') }}</p>
    <div class="text-right q-gutter-sm q-mt-sm">
      <Button :label="$t('Cancel')" color="standard" flat @click="currentVisible = false" />
      <Button
        :label="$t('Delete')"
        color="negative"
        @click="onSubmit"
        :disabled="loading"
        :loading="loading"
      />
    </div>
  </Dialog>
</template>

<script>
import { mapActions } from 'vuex';
import Button from '@design-system/components/Button.vue';
import Dialog from '@design-system/components/Dialog.vue';

const messages = {
  en: {
    'Are you sure?': 'Are you sure?',
    'This operation can not be canceled.': 'This operation can not be canceled.',
    Cancel: 'Cancel',
    Delete: 'Delete',
  },
  ja: {
    'Are you sure?': '削除します',
    'This operation can not be canceled.': 'この操作は取り消しができません。',
    Cancel: 'キャンセル',
    Delete: '削除する',
  },
};

export default {
  name: 'DeleteModal',
  components: { Button, Dialog },
  i18n: { messages },
  props: {
    value: Boolean,
    deleteId: String,
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    currentVisible: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  methods: {
    ...mapActions('identityProviders', {
      deleteIdentityProviders: 'deleteIdentityProviders',
    }),
    async onSubmit() {
      try {
        // Start Request
        this.loading = true;
        await this.deleteIdentityProviders({ id: this.deleteId });

        // After Request
        this.currentVisible = false;
        await this.$alpha.notify.success('delete');
      } catch (e) {
        await this.$alpha.notify.error('delete');
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
